/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { BrandingUiInfoKeys } from '../../../core/entities';
import { ServicesClientImpl } from '../../../core/interactors';
import { Locale, LocaleKeys } from '../../../core/locale';
import { ScreenTaskControllerTypes } from '../../../core/navigation';
import type { TGetState } from '../../../core/tivo/tivo-redux-wrapper';
import { BrandingUiUtility } from '../../../core/utils';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import type { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../screens/screens.reducers';

const GLOBAL_MOUSE_TRAP = 'VodUpSellOverlay';

export const showVodUpSellOverlay =
    (title: string, subtitle: string) => (dispatch: Function, getState: TGetState) => {
        const { isOverlayDialogActive } = getState().overlayDialog;
        if (isOverlayDialogActive) dispatch(hideOverlayDialog());

        const defaultServices = new ServicesClientImpl();
        const urlUpsell = defaultServices.getBrandingUiInfoForKey(BrandingUiInfoKeys.URL_UPSELL);
        const phoneUpsell = defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.PHONE_UPSELL,
        );

        const description = BrandingUiUtility.formatDescription(
            Locale.getString(
                urlUpsell
                    ? LocaleKeys.VOD_OVERLAY_SUBSCRIPTION_REQUIRED_WITH_URL
                    : LocaleKeys.VOD_OVERLAY_SUBSCRIPTION_REQUIRED,
            ),
            urlUpsell
                ? { PHONE_UPSELL: phoneUpsell, URL_UPSELL: urlUpsell }
                : { PHONE_UPSELL: phoneUpsell },
        );

        const overlayProps: IOverlayDialog = {
            hasDimmer: true,
            hasSeperator: false,
            mouseTrapValue: GLOBAL_MOUSE_TRAP,
            title,
            subtitle,
            description,
            options: [{ text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT) }],
        };
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.VOD_UPSELL_OVERLAY_TASKS));
        dispatch(showOverlayDialog(overlayProps));
    };

export const onKeyOkVodUpSellOverlay = () => (dispatch: Function) => {
    dispatch(hideOverlayDialog());
};

export const onMouseClickVodUpSellOverlay = () => (dispatch: Function, getState: TGetState) => {
    const { value } = getState().inputFactory;

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }

    dispatch(onKeyOkVodUpSellOverlay());
};
